// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20tmy","clinicsSelect":"styles_clinicsSelect__3QjS4"};